<div class="gwc-login">
	<div class="gwc-login__content">
		<div class="gwc-login__form">
			@if (!setup()) {
				<img class="gwc-login__robot"
					srcset="assets/login/img-wally-waving.jpg,
									assets/login/img-wally-waving@2x.jpg 2x"
					src="assets/login/img-wally-waving@2x.jpg"
					alt="Wally Robot" />

				<img class="gwc-login__logo"
					src="assets/login/gov-works.svg"
					alt="Gov Works Logo" />
			}
			<router-outlet></router-outlet>		
		</div>
		<div class="gwc-login__passports">
			<img src="assets/login/login-passports.png" alt="Hand holding passports">
		</div>
	</div>
</div>